import React from "react";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import RefreshIcon from '@material-ui/icons/Refresh';
import { connect } from "react-redux";
import { pushMessage } from "../../redux/actions/commonActions";
import { reinviteUser } from "../../redux/actions/profileScreenActions";

class ResendInvite extends React.Component {
  defaultButtonText = "Resend Invite";

  constructor(props) {
    super(props);
    this.state = {
      disabled: this.props.disabled,
      buttonText: this.defaultButtonText
    };
  }

  handleClick = async () => {
    const { reinviteUser, userEmail, pushMessage } = this.props;
    this.setState({ disabled: true, buttonText: "Sending..." });

    await reinviteUser(userEmail);
    const { reinviteUserApiResponse } = this.props;

    if (reinviteUserApiResponse === 200) {
      pushMessage({ type: "success", message: "Invite resent." });
    } else {
      pushMessage({ type: "error", message: "Failed to resend invite." });
    }

    this.setState({ disabled: false, buttonText: this.defaultButtonText });
  };

  render() {
    const { buttonText, disabled } = this.state;

    return (
      <Tooltip title={buttonText}>
        <IconButton variant="contained" color="secondary" onClick={this.handleClick} disabled={disabled}>
            <RefreshIcon />
        </IconButton>
      </Tooltip>

    );
  }
}

const mapStateToProps = state => {
  return {
    reinviteUserApiResponse: state.profile.reinviteUserApiResponse
  };
};

export default connect(
  mapStateToProps,
  { pushMessage, reinviteUser }
)(ResendInvite);
